import React from 'react';
import TaskTable from './Components/TasksTable/TaskTable';
import MatterInfo from './Components/MatterInfo/MatterInfo';
import MatterMilestones from './Components/Milestone/MatterMilestones';
import TeamWidget from './Components/TeamWidget/TeamWidget';
import QuickActionsWidget from './Components/QuickActionsWidget';
import './GeneralMatters.css';

interface GeneralMattersProps {
  onOpenFilesTab?: () => void;
}

const GeneralMatters: React.FC<GeneralMattersProps> = ({ onOpenFilesTab }) => {
  return (
    <div className="general-matter-container ">
      <div className="general-matter-leftside">
        <div className="general-matter-row general-matter-summary-row">
          <div className="general-matter-summary">
            <MatterInfo />
          </div>
        </div>
        <TaskTable />
      </div>
      <div className="general-matter-rightside">
        <MatterMilestones />
        <TeamWidget />
        <QuickActionsWidget onOpenFilesTab={onOpenFilesTab} />
      </div>
    </div>
  );
};

export default GeneralMatters;
